angular.module('app.components').component('chatAtendente', {
    bindings: {
        chamado: '=',
        origem: '=',
        total: '=?',
        permitirResposta: '=',
        respondido: '&?'
    },
    controller: discussaoCtrl,
    template: require('./atendente.html')
});

discussaoCtrl.$inject = ['$scope', 'Chat', 'notificacao', 'Event', 'Usuario', 'categorizacoesApi']

function discussaoCtrl ($scope, Chat, notificacao, Event, Usuario, categorizacoesApi) 
{
    var $ctrl = this;

    $ctrl.mensagens = [];  
    $ctrl.resposta = {  anexos: [] };
    $ctrl.buscarMensagens = buscarMensagens;
    $ctrl.responder = responder;
    $ctrl.colar = colar;
    $ctrl.chamadoId = null;
    $ctrl.credencial = {};
    $ctrl.situacoes = [];
    $ctrl.buscandoMensagens = true;
    $ctrl.atualizar = true;
    $ctrl.exibirForm = false;

    Event.on('chat:atualizar', function(event, payload){
        if( payload.chamadoId && $ctrl.chamadoId == $ctrl.chamadoId  && $ctrl.atualizar){
            $ctrl.buscarMensagens( $ctrl.chamadoId ).then(function(){
                $ctrl.respondido()
            });
        }

        $ctrl.atualizar = true;
    })($scope)

    /**
     * Obtém a credencial do usuário logado
     */
    Usuario.credencial().then(function ( perfil ) {
        $ctrl.credencial = perfil.data.credencial;
    });

    $ctrl.$onInit = function()
    {
        $ctrl.chamado.then(function(chamado){
            $ctrl.chamadoId = chamado.chamadoId;

            // Indica que as mensagens estão sendo buscadas
            $ctrl.buscandoMensagens = true;

            $ctrl.buscarMensagens( chamado.chamadoId )
        });

        $ctrl.origem = $ctrl.origem || 0;

        // Indica a quantidade de mensagens
        $ctrl.total = $ctrl.total || 0;
    }

    /**
     * Busca as mensagens do chamado
     * 
     * @param {string} chamadoId 
     */
    function buscarMensagens ( chamadoId )
    {
        return $ctrl.mensagensRequest = Chat.mensagens().get({ chamadoId: chamadoId }, function( mensagens ){
            $ctrl.mensagens = mensagens;

            $ctrl.total = mensagens.length;

            $ctrl.buscandoMensagens = false;

            return true;
        }, function () {
            $ctrl.mensagens = [];

             $ctrl.buscandoMensagens = false;
        }).$promise;
    }

    /**
     * Envia uma respsota
     * 
     * @param {object} resposta 
     */
    function responder( resposta )
    {
        $ctrl.atualizar = false;

        var formResposta = new FormData();

        formResposta.append( 'mensagem', _.escape(resposta.mensagem.replace(/'/g, '"')) );

        _.each( resposta.anexos , function (anexo) {
            formResposta.append('Files[]', anexo, anexo.nome);
        });

        Chat.resposta( { chamadoId: $ctrl.chamadoId, origemParticipante: $ctrl.origem } ).enviar( 
            formResposta, 
            function( mensagem ){
                $ctrl.mensagens.unshift( mensagem );

                $ctrl.resposta = { anexos: [] };

                $ctrl.respondido({
                    mensagem: mensagem
                });

                $ctrl.exibirForm = false;
            }, 
            function(error){
                'error'
            }
        )
    } 

        
    /**
     * Ouvinte para o evento colar no formulario
     * de abertura de chamado
     * 
     * @param object $event
     */
    function colar($event) {
        Event.fire( 'anexo.colar-arquivo', $event );
    }

}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/chat/atendente/index.js
// module id = 309
// module chunks = 1